<template>
  <div class="header">
  <div @click="navigate('home')">
    <img src="../assets/logo.png" alt="teller logo" width="160" height="40">
  </div>
  <div>
      <v-btn v-if="page == 'home' && User == null" @click="navigate('login')" class="loginBtn" outlined>
       <span class="loginText"> Login to Account</span> 
      </v-btn>
        <v-btn v-if="User" @click="navigate('dashboard')" class="loginBtn" outlined>
       <span class="loginText">Dashboard</span> 
      </v-btn>
        <v-btn
        class="contactBtn"
       v-if="page != 'ContactUs' && page != 'home'"
        text
        @click="navigate('ContactUs')"
      >
      <span>contact us</span>
      </v-btn>
     <v-btn class="menuBtn"   @click.stop="drawer = !drawer" color="primary" icon>
        <v-icon>mdi-menu</v-icon>
     </v-btn>
  </div>
   <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
    >
      <v-list
      nav
      dense
      >
        <v-list-item v-if="User" @click="navigate('dashboard')">
          <v-list-item-icon class="maicon">
            <v-icon>mdi-apps</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

          <v-list-item v-if="!User" @click="navigate('login')">
          <v-list-item-icon class="maicon">
            <v-icon>mdi-shield-lock</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Login</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

          <v-list-item v-if="!User" @click="navigate('signup')">
          <v-list-item-icon class="maicon">
            <v-icon>mdi-account-plus</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Signup</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
  export default {
    name: 'Hearder',
    data: () => ({
       drawer: false,
      group: null,
    }),
      watch: {
      group () {
        this.drawer = false
      },
    },
    methods: {
      navigate(to){
        this.$router.push({name: to})
      }
    },
    computed: {
      page(){
        return this.$route.name
      },
      User () {
        return this.$store.getters.getUser
    },
    },
  }
</script>

<style scoped>

.header{
  width: 100%;
  display: flex;
  align-items: center;
  padding-right: 50px !important;
  padding-left: 50px !important;
}
.loginText{
  height: 16px;
  font-family: SFProDisplay;
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #452065;
  text-transform: none;
}
.loginBtn{
  width: 183px;
  height: 46px;
  border-radius: 15px;
  border: solid 1px #452065;
  text-transform: none;
}
.contactBtn{
  width: 183px;
  height: 46px;
  text-transform: none;
}
.menuBtn{
 display: none; 
}
img{
  cursor: pointer;
}
.maicon{
  margin-right: 5px;
}
.back{
  font-size: 20px;
}
.padd{
  padding-left: 50px;
  padding-right: 50px;
}
span{
  font-family: 'AvenirLTProBook';
  font-size: 24px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #452065;
}

@media only screen and (max-width: 700px) {
  .loginBtn{
   display: none;
 }
 .menuBtn{
  display: inline;
}
.contactBtn{
  display: none;
}
.header{
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: space-between;
  padding-left: 0px;
  padding-right: 0px;
}
}
</style>
